<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-right">
        <img
          src="//cdn.overmediacast.com/logo_overmedia.png"
          alt="OvermediaCast"
        />
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "BrandChannelFooter"
};
</script>
